import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'
import enView from '../views/enView.vue'
import esView from '../views/esView.vue'
import loginView from '../views/loginView.vue'

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  // {
  //   path: '/about',
  //   name: 'about',
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
  // },
  {
    path: '/es',
    name: 'es',
    component : esView   
  },
  {
    path: '/en',
    name: 'en',
    component: enView,
  },
  {
    path: '/login',
    name: 'login',
    component: loginView,
  }

]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
